import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const PRICE_MODEL_MODULE = 'PRICE_MODEL';

export const DEFAULT_PRICE_MODEL_COLUMNS: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'variable',
    field_name: 'VARIABLE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: true,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: true,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'activated',
    field_name: 'ACTIVATED',
    checked: true,
    order_by: 'deactivated',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const setPriceModelPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, {
        module: PRICE_MODEL_MODULE,
        default_columns: DEFAULT_PRICE_MODEL_COLUMNS,
        default_order_by: 'name',
        default_order: 'asc',
    });
